import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

const VoiceOfFarmers = () => {
    const cardData = [
        {
          image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744235851/image_ai2noe.png',
          title: 'Planning & management',
          location: 'Walvis Bay, Namibia',
        },
        {
          image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744235861/image-1_wkkcij.png',
          title: 'Market',
        },
        {
          image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744235869/image-2_uuqx5g.png',
          title: 'Productivity',
        },
        {
          image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744239433/image-3_lss5jw.png',
          title: 'Expert Advice',
        },
        {
          image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744239433/image-4_rhdunv.png',
          title: 'Easy Communication',
        },
        {
          image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744239433/image-5_pnfckj.png',
          title: 'Secure Payments',
        },
      ];
  return (
    <div className="px-4 md:px-20  bg-white">
      <h2 className="text-[10px] md:text-[45px] font-bold text-black md:pt-2 pt-2 ">Voice  of Farmers</h2>

      <div className="flex flex-row items-end  justify-between md:mt-4 mt-2 " style={{lineHeight:'1.23'}}>
  <p className="text-[8px] md:text-[18px] text-black flex-1 md:flex hidden mb-4 font-medium ">
    Farmers highlight how Farmnet apps help them access timely weather updates, expert agricultural advice, and market information, which improves their decision-making and productivity.
The app is also praised for enabling easy communication with buyers, securing better market prices, and ensuring timely payments.
  </p>
  <p className="text-[9px] md:text-[18px] text-black md:hidden flex w-full">
    Farmers highlight how Farmnet apps help them access timely weather updates, expert agricultural advice, and market information, which improves their decision-making and productivity.
   
  </p>
  <a href='/voiceoffarmermain'>
<img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1749379209/Expand_right_2_stxds0.png" alt='kin' className='md:w-[34px] md:h-[34px] h-[10px] w-[10px]'/> 
  </a>
 <a href='/voiceoffarmermain'>
 <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1749379209/Expand_right_2_stxds0.png" alt='kin' className='md:w-[34px] md:h-[34px] h-[10px] w-[10px]'/> 

 </a>
</div>


      <div className="md:mt-1 mt-2">
      <Swiper
  modules={[Autoplay]}
  slidesPerView={3}
  spaceBetween={20} // default for desktop
  slidesPerGroup={3}
  loop={true}
  autoplay={{
    delay: 2500,
    disableOnInteraction: false,
  }}
  breakpoints={{
    320: { slidesPerView: 3, spaceBetween: 5 }, // 5 logos on mobile, 5px gap
    1024: { slidesPerView: 3, spaceBetween: 20 }, // default for laptop
  }}
>

          {cardData.map((card, index) => (
            <SwiperSlide key={index}>
              <div
                className="md:w-full  w-[105px] h-[150px] md:h-[520px] md:rounded-[10px] rounded-[5px]  relative overflow-hidden bg-cover bg-center"
                style={{ backgroundImage: `url(${card.image})` }}
              >
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
                  alt="Play"
                  className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[25px] h-[25px] md:w-[100px] md:h-[100px] z-10"
                />
                <a href="/">
                  <img
                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744202632/image_1538_bievzn.png"
                    alt="Logo"
                    className="w-[15px] h-[15px] absolute md:bottom-40 bottom-12 md:-left-5 left-2 md:mb-2 mb-3 sm:w-[60px] sm:h-[60px] md:w-[80px] md:h-[50px] xl:w-[140px] xl:h-[80px] object-contain"
                  />
                </a>
                <div className="absolute md:bottom-0 bottom-0 md:left-0 w-full md:p-4 p-1.5">
                <h3 className="text-[8px] md:text-[22px] font-bold text-white px-2" style={{lineHeight:'1.1'}}>{card.title}</h3>
                  <p className="text-[4px] md:text-[18px] font-normal text-white px-2">
                    Farmnet has improved my productivity by linking me with service providers & resources
                  </p>
                  <div className="flex items-center justify-between px-2 mt-2">
                    <div className="flex items-center gap-2">
                      <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744235659/image_20_ujukab.png"
                        alt="Location"
                        className="md:w-5 md:h-5 w-2 h-2"
                      />
                      <p className="text-white text-[6px] md:text-[14px] font-medium flex">
                        <strong className='font-medium md:flex hidden'>Walvis bay, </strong>Namibia
                      </p>
                    </div>
                    <img
                      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744205132/Expand_right_unwap6.png"
                      alt="Person"
                      className="md:w-8 h-3 w-3 md:h-8"
                    />
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default VoiceOfFarmers;
